import React from 'react';
import { useTranslation } from 'react-i18next';
// @ts-ignore
import html2pdf from 'html2pdf.js/dist/html2pdf.min';

export const DownloadButton = () => {
  const { t } = useTranslation('', { keyPrefix: 'BUTTON' });

  const handleClick = () => {
    let content = '';
    content += document.querySelector('header')?.outerHTML ?? '';
    content += '<div style="margin-top: 30px"></div>';
    content += document.querySelector('.container-steps')?.outerHTML ?? '';

    const opt = {
      filename: 'SignUp.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: {
        logging: false,
        scrollX: 0,
        scrollY: 0,
        scale: 3,
      },
      jsPDF: { unit: 'px', format: 'a4', orientation: 'portrait', hotfixes: ['px_scaling'] },
      pagebreak: { mode: '', avoid: '.avoid-break' },
    };
    html2pdf().set(opt).from(content).toPdf().save();
  };

  return (
    <button type="button" className="n2pc-btn-text download-button" onClick={handleClick}>
      {t('DOWNLOAD_PDF')}
    </button>
  );
};
